/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { mapBlessedTombs } from '../fn/map/map-blessed-tombs';
import { MapBlessedTombs$Params } from '../fn/map/map-blessed-tombs';
import { mapCinema } from '../fn/map/map-cinema';
import { MapCinema$Params } from '../fn/map/map-cinema';
import { mapCulturalCenters } from '../fn/map/map-cultural-centers';
import { MapCulturalCenters$Params } from '../fn/map/map-cultural-centers';
import { mapLegalDigitalCulturalInstitutions } from '../fn/map/map-legal-digital-cultural-institutions';
import { MapLegalDigitalCulturalInstitutions$Params } from '../fn/map/map-legal-digital-cultural-institutions';
import { mapLibraries } from '../fn/map/map-libraries';
import { MapLibraries$Params } from '../fn/map/map-libraries';
import { mapMosques } from '../fn/map/map-mosques';
import { MapMosques$Params } from '../fn/map/map-mosques';
import { mapNationalComputerGamesFoundation } from '../fn/map/map-national-computer-games-foundation';
import { MapNationalComputerGamesFoundation$Params } from '../fn/map/map-national-computer-games-foundation';
import { mapPublishers } from '../fn/map/map-publishers';
import { MapPublishers$Params } from '../fn/map/map-publishers';
import { mapQuranicInstitutes } from '../fn/map/map-quranic-institutes';
import { MapQuranicInstitutes$Params } from '../fn/map/map-quranic-institutes';

@Injectable({ providedIn: 'root' })
export class MapService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mapNationalComputerGamesFoundation()` */
  static readonly MapNationalComputerGamesFoundationPath = '/NationalComputerGamesFoundation';

  /**
   * بنیاد ملی بازی های رایانه ای.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapNationalComputerGamesFoundation()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapNationalComputerGamesFoundation$Response(params?: MapNationalComputerGamesFoundation$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return mapNationalComputerGamesFoundation(this.http, this.rootUrl, params, context);
  }

  /**
   * بنیاد ملی بازی های رایانه ای.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapNationalComputerGamesFoundation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapNationalComputerGamesFoundation(params?: MapNationalComputerGamesFoundation$Params, context?: HttpContext): Observable<Blob> {
    return this.mapNationalComputerGamesFoundation$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `mapBlessedTombs()` */
  static readonly MapBlessedTombsPath = '/BlessedTombs';

  /**
   * بقاع متبرکه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapBlessedTombs()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapBlessedTombs$Response(params?: MapBlessedTombs$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return mapBlessedTombs(this.http, this.rootUrl, params, context);
  }

  /**
   * بقاع متبرکه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapBlessedTombs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapBlessedTombs(params?: MapBlessedTombs$Params, context?: HttpContext): Observable<Blob> {
    return this.mapBlessedTombs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `mapPublishers()` */
  static readonly MapPublishersPath = '/Publishers';

  /**
   * انتشارات.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapPublishers()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapPublishers$Response(params?: MapPublishers$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return mapPublishers(this.http, this.rootUrl, params, context);
  }

  /**
   * انتشارات.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapPublishers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapPublishers(params?: MapPublishers$Params, context?: HttpContext): Observable<Blob> {
    return this.mapPublishers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `mapCulturalCenters()` */
  static readonly MapCulturalCentersPath = '/CulturalCenters';

  /**
   * مراکز فرهنگی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapCulturalCenters()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapCulturalCenters$Response(params?: MapCulturalCenters$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return mapCulturalCenters(this.http, this.rootUrl, params, context);
  }

  /**
   * مراکز فرهنگی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapCulturalCenters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapCulturalCenters(params?: MapCulturalCenters$Params, context?: HttpContext): Observable<Blob> {
    return this.mapCulturalCenters$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `mapMosques()` */
  static readonly MapMosquesPath = '/Mosques';

  /**
   * کانون مساجد.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapMosques()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapMosques$Response(params?: MapMosques$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return mapMosques(this.http, this.rootUrl, params, context);
  }

  /**
   * کانون مساجد.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapMosques$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapMosques(params?: MapMosques$Params, context?: HttpContext): Observable<Blob> {
    return this.mapMosques$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `mapCinema()` */
  static readonly MapCinemaPath = '/Cinema';

  /**
   * سینما.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapCinema()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapCinema$Response(params?: MapCinema$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return mapCinema(this.http, this.rootUrl, params, context);
  }

  /**
   * سینما.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapCinema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapCinema(params?: MapCinema$Params, context?: HttpContext): Observable<Blob> {
    return this.mapCinema$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `mapLegalDigitalCulturalInstitutions()` */
  static readonly MapLegalDigitalCulturalInstitutionsPath = '/LegalDigitalCulturalInstitutions';

  /**
   * موسسات فرهنگی دیجیتال حقوقی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapLegalDigitalCulturalInstitutions()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapLegalDigitalCulturalInstitutions$Response(params?: MapLegalDigitalCulturalInstitutions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return mapLegalDigitalCulturalInstitutions(this.http, this.rootUrl, params, context);
  }

  /**
   * موسسات فرهنگی دیجیتال حقوقی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapLegalDigitalCulturalInstitutions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapLegalDigitalCulturalInstitutions(params?: MapLegalDigitalCulturalInstitutions$Params, context?: HttpContext): Observable<Blob> {
    return this.mapLegalDigitalCulturalInstitutions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `mapQuranicInstitutes()` */
  static readonly MapQuranicInstitutesPath = '/QuranicInstitutes';

  /**
   * موسسه قرآنی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapQuranicInstitutes()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapQuranicInstitutes$Response(params?: MapQuranicInstitutes$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return mapQuranicInstitutes(this.http, this.rootUrl, params, context);
  }

  /**
   * موسسه قرآنی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapQuranicInstitutes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapQuranicInstitutes(params?: MapQuranicInstitutes$Params, context?: HttpContext): Observable<Blob> {
    return this.mapQuranicInstitutes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `mapLibraries()` */
  static readonly MapLibrariesPath = '/Libraries';

  /**
   * کتابخانه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapLibraries()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapLibraries$Response(params?: MapLibraries$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return mapLibraries(this.http, this.rootUrl, params, context);
  }

  /**
   * کتابخانه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapLibraries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapLibraries(params?: MapLibraries$Params, context?: HttpContext): Observable<Blob> {
    return this.mapLibraries$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
